export default __webpack_public_path__ + "images/VV.9df75fd.png";